import styled from '@bd/bdui-styles/emotion';
import FilterBar from '@bd/bdui-filterbar';
import { colors } from '../styles';

export default styled(FilterBar)`
  position: relative;
  z-index: 3;
  @media(min-width: 992px) {
    z-index: 1;
    display: inline-block;
    vertical-align: top;
  }
  .FilterBar_wrapper {
    position: relative;
    z-index: 1;
  }
  .FilterBar_list {
    list-style: none;
    padding: 0;
    margin: 0;
    vertical-align: top;
    display: flex;
    flex-direction: column;
    @media(min-width: 992px) {
      display: inline-block;
    }
    .FilterBar_listItem {
      display: inline-block;
      font-weight: 800;
      font-size: 16px;
      color: ${colors.body};
      vertical-align: top;
    }
  }
  .FilterSelect_title {
    padding: 0 20px;
    cursor: pointer;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.neutral};
    background-color: ${colors.white};
    @media(min-width: 992px) {
      border-bottom: 0;
      border-right: 1px solid ${colors.neutral};
      justify-content: flex-start;
    }
    &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand3};
      position: relative;
      margin: 0 0 0 5px;
    }
  }
  .FilterSelect_dropdown {
    position: relative;
    list-style: none;
    padding: 10px;
    background-color: ${colors.whiteDark};
    min-width: 200px;
    width: 100%;
    z-index: 2;
    @media(min-width: 992px) {
      width: auto;
      position: absolute;
      box-shadow: 0 10px 15px 0 rgba(0,0,0,0.50);
      padding: 20px 10px;
      background-color: ${colors.white};
    }
  }
  .FilterSelect_dropdownItem {
    font-weight: 300;
    font-size: 16px;
    color: ${colors.body};
    border-bottom: 1px solid ${colors.neutral};
    width: 100%;
    white-space: nowrap;
    &:last-child {
      border: 0;
    }
  }
  .FilterSelect_dropdownItemButton {
    padding: 10px 0;
    display: inline-block;
    cursor: pointer;
    width: calc(100% - 30px);
  }
  .FilterSelect_dropdownItemCheckbox {
    display: inline-block;
    width: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/FilterBar.js